"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequestStatusMeta = createRequestStatusMeta;
exports.createRequestAction = createRequestAction;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var RequestStatusTypes = _interopRequireWildcard(require("MeetingsBase/constants/RequestStatusTypes"));

function getStatusIndex(type) {
  var statusIndex = type ? type.lastIndexOf('_') : -1;

  if (statusIndex === -1) {
    throw new Error("exected an request action type in the form of ${NAMESPACE}_${REQUEST_STATUS} but received " + type);
  }

  return statusIndex;
}

function getRequestNamespace(type) {
  var statusIndex = getStatusIndex(type);
  return type.substring(0, statusIndex);
}

function getRequestStatus(type) {
  var statusIndex = getStatusIndex(type);
  var requestStatus = type.substring(statusIndex + 1);
  (0, _invariant.default)(RequestStatusTypes.hasOwnProperty(requestStatus), 'expected `requestStatus` to be defined in `MeetingsBase/constants/RequestStatusTypes` but got `%s`', requestStatus);
  return requestStatus;
}

function createRequestStatusMeta(type) {
  var namespace = getRequestNamespace(type);
  var requestStatus = getRequestStatus(type);
  return {
    request: {
      key: namespace,
      status: requestStatus
    }
  };
}

function createRequestAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var metadataCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  return (0, _fluxActions.createAction)(type, payloadCreator, function () {
    return (0, _extends2.default)({}, metadataCreator.apply(void 0, arguments), createRequestStatusMeta(type));
  });
}